import Vue from "vue";

import Page from "@/components/parts/Page";
import Sidebar from "@/components/parts/Sidebar";
import LayoutAuth from "@/components/layouts/LayoutAuth";
import LayoutMain from "@/components/layouts/LayoutMain";
import PageHeader from "@/components/parts/PageHeader";
import CardFooter from "@/components/parts/CardFooter";
import PartialTwoCol from "@/components/layouts/TwoCol";
import CardInsideHeader from "@/components/parts/CardInsideHeader";

Vue.component("page", Page);
Vue.component("sidebar", Sidebar);
Vue.component("layout-auth", LayoutAuth);
Vue.component("layout-main", LayoutMain);
Vue.component("partial-two-col", PartialTwoCol);
Vue.component("page-header", PageHeader);
Vue.component("card-footer", CardFooter);
Vue.component("card-inside-header", CardInsideHeader);
